import React from 'react';

const MonitorReports = () => <h1 className="pageTitle">Reports</h1>;

export default MonitorReports;
